import {OnlineSessionsViewType} from 'enums';
import {CustomField, OnlineSessionsStore, SocketDataStore} from 'interfaces';
import {Observable} from 'services/Observable';
import {AccountPlanStore, AssignmentData, AuthDataStore, PictureInPictureStore, UserActiveSessionStore, inSessionStore} from 'types';

import {MediaDevicesStorage, MediaDevicesStorageData} from './MediaDevices';

export const onlineSessionsStore = new Observable<OnlineSessionsStore>({
    sessions: [],
    sessionsLoaded: false,
    screenRecorderState: null,
    joiningSessionId: null,
    error: null
});

export const socketStore = new Observable<SocketDataStore>({
    connected: false,
    authenticated: false
});

export const accountPlanStore = new Observable<AccountPlanStore>({
    planId: null,
    limits: null,
    hasBillingPlatformProfile: false,
    usage: {
        inSessionMinutes: null
    }
});

export const onlineSessionsViewTypeStore = new Observable<OnlineSessionsViewType>(null);

export const authDataStore = new Observable<AuthDataStore>({} as AuthDataStore);

export const mediaDevicesStore = new Observable<MediaDevicesStorageData>(MediaDevicesStorage.getItem());

export const userActiveSessionStore = new Observable<UserActiveSessionStore>(null);

export const userInfoSchemaStore = new Observable<AssignmentData<CustomField[]>[]>([]);

export const guestUserInfoSchemaStore = new Observable<AssignmentData<CustomField[]>[]>([]);

export const inSessionDataStore = new Observable<inSessionStore>({videoPinParticipant: null});

export const pictureInPictureStore = new Observable<PictureInPictureStore>({
    active: false,
    enabled: false,
    supported: false,
});
